var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66663C5.40008 1.66663 1.66675 5.39996 1.66675 9.99996C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99996C18.3334 5.39996 14.6001 1.66663 10.0001 1.66663Z",
    fill: "#00008E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 6.85006C10.8334 7.31029 10.4603 7.68339 10.0001 7.68339C9.53984 7.68339 9.16675 7.31029 9.16675 6.85006C9.16675 6.38982 9.53984 6.01672 10.0001 6.01672C10.4603 6.01672 10.8334 6.38982 10.8334 6.85006Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 9.50663C9.16675 9.31885 9.31897 9.16663 9.50675 9.16663H10.4934C10.6812 9.16663 10.8334 9.31885 10.8334 9.50663V13.8266C10.8334 14.0144 10.6812 14.1666 10.4934 14.1666H9.50675C9.31897 14.1666 9.16675 14.0144 9.16675 13.8266V9.50663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a7f913f4f9bf89b17eb3acf817c8fc46.svg";
export { ForwardRef as ReactComponent };